"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskType = exports.TaskStates = exports.TaskMode = void 0;
var TaskMode;
(function (TaskMode) {
    TaskMode[TaskMode["SELECT"] = 0] = "SELECT";
    TaskMode[TaskMode["OPEN"] = 1] = "OPEN";
    TaskMode[TaskMode["OPEN_PARENTS"] = 2] = "OPEN_PARENTS";
})(TaskMode = exports.TaskMode || (exports.TaskMode = {}));
var TaskStates;
(function (TaskStates) {
    TaskStates[TaskStates["DRAFT"] = 0] = "DRAFT";
    TaskStates[TaskStates["AVAILABLE"] = 1] = "AVAILABLE";
    TaskStates[TaskStates["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    TaskStates[TaskStates["COMPLETE"] = 3] = "COMPLETE";
    TaskStates[TaskStates["DECLINED"] = 8] = "DECLINED";
    TaskStates[TaskStates["DELETED"] = 9] = "DELETED";
})(TaskStates = exports.TaskStates || (exports.TaskStates = {}));
var TaskType;
(function (TaskType) {
    TaskType[TaskType["DEFAULT"] = 0] = "DEFAULT";
    TaskType[TaskType["PROJECT"] = 1] = "PROJECT";
    TaskType[TaskType["MEETING"] = 2] = "MEETING";
    TaskType[TaskType["EVENT"] = 3] = "EVENT";
    TaskType[TaskType["EVENT_REPEATING"] = 4] = "EVENT_REPEATING";
    TaskType[TaskType["ROOM"] = 5] = "ROOM";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
//# sourceMappingURL=taskItem.js.map